import React from 'react';
import ReactDOM from 'react-dom';
import ApplicationList from './application_list';
import getComponentWithTheme from '../../themeProvider';

const ajax = require('sma.common/ajax');
const Grid = require('sma.admin/components/grid');
const modals = require('sma.common/components/modals');
const { DownloadModal } = require('sma.common/downloads');
const ApplicantDecisionModal = require('sma.applicant/components/decision');

const paginationBtns = require('sma.applicant/components/partials/pagination.mustache');
const actionRequiredTempl = require('sma.applicant/dashboard/partials/action_required.mustache');

const VIEWS = {
	GRID: 0,
	LIST: 1,
};

const STRINGS = {
	applicationLocked: gettext('Application is locked'),
	next: gettext('Next'),
	previous: gettext('Previous'),
	of: gettext('of'),
	program: gettext('Program'),
	deadline: gettext('Deadline'),
	applications: gettext('Applications'),
	application: gettext('Application'),
	status: gettext('Status'),
	completion: gettext('Completion'),
	last_edited: gettext('Last edited'),
	reopen: gettext('Reopen'),
	download: gettext('Download'),
	preview: gettext('Preview'),
	view: gettext('View'),
	continue: gettext('Continue'),
	start: gettext('Start'),
	action_required: gettext('Action Required'),
	awarded: gettext('Awarded'),
	submitted_on: gettext('Submitted on'),
	declined: gettext('Declined'),
	submitted: gettext('Submitted'),
	not_started: gettext('Not started'),
	in_progress: gettext('In progress'),
	close: gettext('Close'),
	go_to_app: gettext('Go to application'),
	action_required_on_app: gettext('Action required on your application'),
	decision_made_on_app: gettext('A decision has been made on your application'),
	delete: gettext('Delete'),
	delete_application: gettext('Delete your application'),
	delete_confirm: gettext('Are you sure you want to delete your application? You won\'t be able to undo this action'),
	withdraw: gettext('Withdraw'),
	withdrawn: gettext('Withdrawn'),
	withdraw_application: gettext('Withdraw your application'),
	withdraw_confirm: gettext('Are you sure you want to withdraw your application? You won\'t be able to undo this action'),
	applicant_declined: gettext('You have declined this award'),
};

class Dashboard extends Backbone.View {
	get events() {
		return {
			'click .sma-js-grid-view': 'setGridView',
			'click .sma-js-list-view': 'setListView',
			'click .sma-js-dashboard-prev': 'previousPage',
			'click .sma-js-dashboard-next': 'nextPage',
			'click #sma-js-dashboard-filter a.dropdown-item': 'filter',
		};
	}

	get $applicationList() {
		return $('.sma-js-application-list');
	}

	get $applicationGrid() {
		return $('.sma-js-application-grid');
	}

	get $pagination() {
		return $('.sma-js-dashboard-pagination');
	}

	set VIEW(v) {
		localStorage.setItem('applicantApplicationsView', v);
	}

	get VIEW() {
		const viewStored = parseInt(localStorage.getItem('applicantApplicationsView'));
		return _.values(VIEWS).indexOf(viewStored) != -1 ? viewStored : VIEWS.GRID;
	}

	constructor(config) {
		super();

		this.VIEW === VIEWS.GRID
			? this.setGridView() : this.setListView();

		this.setElement($('body'));

		this.VIEW = VIEWS.GRID;

		this.params = {
			page: 1,
		};

		this.load();
	}

	load() {
		const ordering = localStorage.getItem('applicantApplicationsGrid');
		const ordering_direction = localStorage.getItem('dir.applicantApplicationsGrid');
		if (ordering) {
			if (ordering_direction === 'asc') {
				this.params.ordering = ordering;
			} else if (ordering_direction === 'desc') {
				this.params.ordering = `-${ordering}`;
			}
		}

		const url = `${reverse('application-list-datasource')}?${$.param(this.params)}`;

		if (this.params.hasOwnProperty('ordering')) {
			delete this.params.ordering;
		}

		ajax.get({
			url,
			loaderElement: $('.sma-js-application-grid-container'),
			loaderSize: 'lg',
			callback: (response) => {
				this.applications = response.results;
				this.count = response.application_count;
				this.next = response.has_next;
				this.previous = response.has_previous;
				this.render();
			},
		});
	}

	render(context) {
		ReactDOM.unmountComponentAtNode(this.$applicationGrid[0]);

		const url = reverse('application-list-datasource');

		new ApplicationGrid({
			element: this.$applicationList,
			url,
			sortCacheKey: 'applicantApplicationsGrid',
			extraData: this.params,
			results: {
				count: this.count,
				results: this.applications,
			},
		});
		ReactDOM.render(
			getComponentWithTheme(
				<ApplicationList
					applications={this.applications}
				/>,
				window.LOCALE.theme,
			),
			document.getElementsByClassName('sma-js-application-grid')[0],
		);

		$('[data-toggle="tooltip"]').tooltip();

		this.renderPagination();

		this.checkForActionRequired();
	}

	renderPagination() {
		this.$pagination.empty();
		if (this.applications.length === 0) return;

		const lbound = ((this.params.page - 1) * 12);
		const ubound = lbound + this.applications.length;

		this.$pagination.html($(paginationBtns({
			next: this.next,
			previous: this.previous,
			strings: STRINGS,
			text: `${lbound + 1} - ${ubound} ${STRINGS.of} ${this.count} ${STRINGS.applications}`,
		})));
	}

	setGridView() {
		this.VIEW = VIEWS.GRID;
		this.$applicationGrid.show();
		this.$applicationList.hide();
		$('.sma-js-grid-view').addClass('sma-dashboard-toggle-active');
		$('.sma-js-list-view').removeClass('sma-dashboard-toggle-active');
	}

	setListView() {
		this.VIEW = VIEWS.LIST;
		this.$applicationGrid.hide();
		this.$applicationList.show();
		$('.sma-js-grid-view').removeClass('sma-dashboard-toggle-active');
		$('.sma-js-list-view').addClass('sma-dashboard-toggle-active');
	}

	previousPage(e) {
		e.preventDefault();
		if (this.params.page == 1) return;
		this.params.page = this.params.page - 1;
		this.load();
	}

	nextPage(e) {
		e.preventDefault();
		this.params.page = this.params.page + 1;
		this.load();
	}

	filter(e) {
		e.preventDefault();

		const val = $(e.target).attr('href');

		$('#sma-js-dashboard-filter-label').text($(e.target).text());

		this.params.filter = val;
		this.params.page = 1;
		this.load();
	}

	checkForActionRequired() {
		const applicationsWithDecision = this.applications.filter((app) => (
			app.decision.decision_visible === true
		));
		applicationsWithDecision.forEach((app) => {
			if (!app.decision.decision_visible) {
				return;
			}
			if (app.decision.show_decision_required_message && app.decision.applicant_decision === 0) {
				const opts = {
					title: gettext('You have been awarded!'),
					size: 'md',
					bodyClass: 'sma-applicant-decision-modal-wrapper',
					autoShow: true,
					onClose() {
						this.deferDecision();
					},
				};
				const ctx = {
					submission: app,
				};
				const applicantDecisionModal = new ApplicantDecisionModal(opts, ctx);
			} else if (app.needs_attention && !app.decision.applicant_decision_required) {
				const content = actionRequiredTempl({
					submission: app,
					strings: STRINGS,
				});
				const appId = app.id;
				const options = {
					autoShow: true,
					destroyOnClose: true,
					title: STRINGS.decision_made_on_app,
					buttons: [
						{
							cls: 'btn-loud',
							label: STRINGS.close,
							handler: (modal) => {
								modal.closeModal();
							},
						}, {
							cls: 'btn-loud btn-warning',
							label: STRINGS.go_to_app,
							handler: (modal) => {
								window.location.href = modal.nextUrl;
							},
						},
					],
					onShow() {
						this.nextUrl = app.url;
					},
					onClose() {
						const options2 = {
							url: reverse('clear-application-needs-attention', { app_id: appId }),
							callback: () => {
							},
							alertOnSuccess: false,
						};
						ajax.post(options2);
					},
				};
				const needsAttentionModal = new modals.ContentModal(content, options);
			}
		});
	}
}

let ApplicationGrid = Grid.Grid.extend({
	loaderSize: 'lg',
	columns: [
		{
			id: 'award',
			name: STRINGS.program,
			sortable: true,
			formatter(item, grid) {
				let icon = '';

				const awarded = gettext('Application has been awarded');
				const declined = gettext('Application has been declined');

				if (item.decision.awarded) {
					icon = `<i class="nc-icon-mini sport_trophy" aria-hidden="true"></i><span class="sr-only">${awarded}</span>`;
				} else if (item.decision.declined) {
					icon = `<i class="nc-icon-mini ui-1_circle-remove" aria-hidden="true"></i><span class="sr-only">${declined}</span>`;
				}

				return `${icon} ${item.award.name}`;
			},
		}, {
			id: 'title',
			sortable: true,
			name: STRINGS.application,
			formatter(item, grid) {
				let icon = '';
				let members = '';

				const locked = gettext('Application is locked');

				if (item.is_locked) {
					icon = `<i class="nc-icon-mini ui-1_lock" aria-hidden="true"></i><span class="sr-only">${locked}</span>`;
				}

				if (item.collaborator_count) {
					const members_text = interpolate(
						ngettext('%s member', '%s members', item.collaborator_count),
						[item.collaborator_count],
					);

					members = `<i class="nc-icon-mini users_multiple-19 ml-2"
						data-toggle="tooltip" title="${members_text}"></i>`;
				}

				return `${icon} ${item.title} ${members}`;
			},
		}, {
			id: 'deadline',
			sortable: true,
			name: STRINGS.deadline,
			formatter(item, grid) {
				return item.deadline;
			},
		}, {
			id: 'status',
			sortable: true,
			name: STRINGS.status,
		}, {
			id: 'completion',
			name: STRINGS.completion,
			sortable: true,
			formatter(item, grid) {
				if (item.is_submitted && item.progress.pct == 100) {
					return `<i class="nc-icon-mini ui-1_check-circle-08" aria-hidden="true"></i> ${STRINGS.submitted}`;
				}
				return item.progress.msg;
			},
		}, {
			id: 'last_edited',
			sortable: true,
			name: STRINGS.last_edited,
		}, {
			id: 'link',
			name: '',
			formatter(item, grid) {
				const tmpl = (msg, cls) => `<div class="text-right"><a href="${item.url}" class="${cls} sma-applicant-cta btn btn-sm btn-loud">
						<strong>${msg}</strong></a></div>`;

				if (item.decision.show_decision_required_message) return tmpl(STRINGS.action_required, 'sma-application-actn-required');

				if (item.progress.show_start) return tmpl(STRINGS.start, 'sma-application-start');

				if (item.progress.show_continue) return tmpl(STRINGS.continue, 'sma-application-continue');

				return tmpl(STRINGS.view, 'sma-application-view');
			},
		},
	],
	actions: [
		{
			name: 'download',
			text: STRINGS.download,
			action: (args) => {
				const context = {
					submission_ids: args.ids,
				};

				new DownloadModal(context);
			},
		},
	],
	showTitlebar: false,
	showSearchBar: false,
	showFooter: false,
	showColumnDropSelect: false,
});

module.exports = {
	Dashboard,
};
